import styled from '@emotion/styled';

export const StyledContainer = styled('div')(() => ({
  height: 90,
  maxHeight: 90,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 24px',
}));

export const StyledEmptySpace = styled('div')(() => ({
  maxWidth: '90%',
  width: '90%',
}));
